import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatVoucherStatusLabel } from '#/modules/finMgmt/vouchers/helper/voucherStatus';

const VoucherStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatVoucherStatusLabel(status)}
    size={size}
    className={className}
  />
);

VoucherStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default VoucherStatusBadge;
